module.exports = __webpack_public_path__ + "img/tonghua3.be6aec2e.png";